import * as React from 'react'
import EmailIcon from '../../assets/svgIcons/EmailIcon'
import PinIcon from '../../assets/svgIcons/PinIcon'
import WhatsappIcon from '../../assets/svgIcons/WhatsappIcon'
import './styles.scss'

export interface ButtonProps extends React.ComponentPropsWithoutRef<'button'> {
	title: any
	variant:
		| 'outline'
		| 'standard'
		| 'outline-dark'
		| 'dark'
		| 'cancellation'
		| 'cancellation-gradient'
		| 'confirmation'
		| 'confirmation-gradient'
		| 'outline-highlight'
		| 'confirmation-solid'
		| 'confirmation-radius'
		| 'whatsApp'
		| 'email'
		| 'search'
	size: 'sm' | 'md' | 'lg'
	icon?: 'e-mail' | 'whatsApp' | 'pin'
	isLoading?: boolean
}

export const Button = ({
	variant,
	title,
	size,
	icon,
	isLoading = false,
	...rest
}: ButtonProps) => {

	const handleIcon = (icon?: string) => {
			switch (icon) {
				case 'whatsApp':
					return <WhatsappIcon />
				case 'e-mail':
					return <EmailIcon />
				case 'pin':
					return <PinIcon />
				default:
					return ''
			}
	}
  
	return (
		<button
			className={`button-${variant} button-${size}`}
			disabled={isLoading}
			{...rest}
		>
			{handleIcon(icon)}
			{title}
		</button>
	)
}
